import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  sales: "/payments/",
  productSale: "/payments/products",
};

// Retorno de todas as vendas
export const fetchSales = createAsyncThunk(
  "sales/fetchSales",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.sales, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteSale = createAsyncThunk(
  "sales/deleteSales",
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`${endpoint.sales}${id}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const patchSale = createAsyncThunk(
  "sales/patchSale",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(
        `${endpoint.sales}${data.id}/settlement-payment`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

// Create a standalone product sale
export const createProductSale = createAsyncThunk(
  "sales/createProductSale",
  async (
    data: {
      client_id: number | null;
      productSale: Array<{ product_id: number | string; quantity: number }>;
      discount_amount?: number;
      tip_amount?: number;
      change_given?: number;
      payment_details: Array<{
        paid_amount: number;
        payment_method_id: number | string;
      }>;
    },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.post(endpoint.productSale, data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage =
          (error?.response?.data as any)?.message || error.message;
        return thunkAPI.rejectWithValue({ error: errorMessage });
      }
      return thunkAPI.rejectWithValue({ error: "An unknown error occurred" });
    }
  },
);
